import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.scss']
})
export class QuotationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
